<div class="logout-panel">
  <div class="brand">
    <img class="logo" [src]="'assets/plateformebeneficiaire/images/logo.png'" alt="logo" />
    <h2 class="app-name ml-0 sm:ml-2">{{ 'application_name' | translate }}</h2>
  </div>
  <hr>
  <p class="logout-message">Vous êtes désormais déconnecté(e)</p>

  <p class="footer-message"><i>Vous pouvez maintenant quitter cette page</i></p>
  <div class="home-btn-container">
    <button class="home-btn" (click)="goToHome()">Retour à l'accueil</button>
  </div>
</div>

<style>
  :host {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    width: 100%;
    background-size: cover;
  }

  .logout-panel {
    width: 50%;
    border-radius: 10px;
    background-color: white;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
    text-align: center;
    padding: 2rem;
  }

  .logout-message {
    font-size: 18px;
    margin-top: 20px;
  }

  .footer-message {
    font-size: 14px;
    margin-top: 10px;
    color: #666;
  }

  .brand {
    text-align: center;
    margin: 0 auto;
    display: flex;
    align-items: center;
    /* Aligne le texte verticalement au centre */
    justify-content: center;
    /* Centre horizontalement */
    max-width: 221px;
    margin-bottom: 20px;
  }

  .logo {
    max-height: 125px;
    margin-right: 10px;
    /* Ajoute un espace entre le logo et le texte */
  }

  .app-name {
    margin: 0;
    /* Supprime les marges par défaut */
    font-weight: 500;
    font-size: xxx-large;
    margin-left: 10px;
  }

  @media (max-width: 640px) {
    .brand {
      flex-direction: column;
      max-width: 100%;
    }

    .logo {
      margin-right: 0;
      margin-bottom: 10px;
    }

    .app-name {
      font-family: "Pacifico", cursive;
      margin-left: 0;
      font-size: xxx-large;
    }
  }

  .home-btn-container {
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }

  .home-btn {
    background-color: #1976d2;
    color: #fff;
    border: none;
    border-radius: 5px;
    padding: 10px 24px;
    font-size: 16px;
    cursor: pointer;
    transition: background 0.2s;
  }

  .home-btn:hover {
    background-color: #125ea2;
  }
</style>